import { jsx as _jsx } from "react/jsx-runtime";
const variantClasses = {
    pane: 'sam-glass sam-glass-rim rounded-[var(--sam-radius-pane)]',
    quiet: 'sam-glass sam-glass--quiet sam-glass-rim rounded-[var(--sam-radius-pane)]',
    slab: 'sam-glass sam-glass--slab sam-glass-rim rounded-[var(--sam-radius-slab)]',
    // The normal pane fill under its own blur: text on a drawer must stay 4.5:1 whatever passes
    // behind it, and a thinner fill let busy content read through in the light theme.
    overlay: 'sam-glass sam-glass-live sam-glass-rim rounded-[var(--sam-radius-pane)]',
};
/**
 * The classes a Pane renders with, for elements that must be one but render elsewhere.
 * `rounded: false` leaves the corners to the caller (a bottom sheet rounds only its top).
 */
export function paneClassName(variant = 'pane', { rounded = true } = {}) {
    const classes = variantClasses[variant];
    return rounded ? classes : classes.replace(/ rounded-\[[^\]]+\]/, '');
}
export function Pane({ variant = 'pane', as: Component = 'section', className = '', children, ...props }) {
    return (_jsx(Component, { ...props, className: `${variantClasses[variant]} ${className}`, children: children }));
}
/** A 1px hairline between groups inside a pane. */
export function PaneSeparator({ className = '' }) {
    return _jsx("div", { "aria-hidden": "true", className: `h-px shrink-0 bg-[var(--sam-hairline)] ${className}` });
}
//# sourceMappingURL=Pane.js.map